import HierarchySelectorNodeRenderer from "./HierarchySelectorNodeRenderer";

export default class ExpandCollapseNodeRenderer extends HierarchySelectorNodeRenderer {
    constructor(tree, selectorFilter, expandCollapseCallback) {
        super(tree, selectorFilter);
        this.expandCollapseCallback = expandCollapseCallback;
    }

    generateContent(treeNode, targetEl) {
        const tableEl = document.createElement("table");
        const tBodyEl = document.createElement("tbody");
        const trEl = document.createElement("tr");
        const checkboxTdEl = document.createElement("td");
        const collapseTdEl = document.createElement("td");

        //visibility of this buttons are maintained by css
        const normalExpandCollapseButton = this.generateExpandCollapseButton(treeNode, true, "normalExpandCollapseButton", null);
        const disabledExpandCollapseButtonWithTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithTitle", this.getExpandCollapseButtonTitle(treeNode));
        const disabledExpandCollapseButtonWithoutTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithoutTitle", null);

        tableEl.appendChild(tBodyEl);
        tBodyEl.appendChild(trEl);
        trEl.appendChild(checkboxTdEl);
        trEl.appendChild(collapseTdEl);
        collapseTdEl.appendChild(normalExpandCollapseButton);
        collapseTdEl.appendChild(disabledExpandCollapseButtonWithTitle);
        collapseTdEl.appendChild(disabledExpandCollapseButtonWithoutTitle);

        const spacerDiv = document.createElement("div");
        spacerDiv.className = "spacer";
        spacerDiv.innerHTML = "<b></b>"; // for IE to display correctly

        targetEl.appendChild(tableEl);
        targetEl.appendChild(spacerDiv);

        super.generateContent(treeNode, checkboxTdEl);
    }

    generateExpandCollapseButton(treeNode, withOnClick, additionalClass, title) {
        const expandCollapseBtn = document.createElement("div");
        expandCollapseBtn.className = "collapseButton " + additionalClass;
        const context = this;
        expandCollapseBtn.onclick = (withOnClick) ? function() {
            context.expandCollapseCallback(function() {
                const expandController = context.tree.getExpandController();
                if (expandController.isCollapsed(treeNode))
                    expandController.expandAndScrollIfNeeded(treeNode);
                else
                    expandController.collapse(treeNode);
                //Fix bug for IE ( :active style doesn't disappear after click )
                expandCollapseBtn.blur();
            });
        } : function() {};
        if (title) {
            expandCollapseBtn.title = title;
        }
        return expandCollapseBtn;
    }

    getExpandCollapseButtonTitle(treeNode) {
        if (this.tree.hasActiveFilter() && !this.tree.getActiveFilter().hasKeywordFilter() && !this.tree.doesContainChildrenMatchingFilterCriteria(treeNode)) {
            return this.getEmptyEntityTooltip();
        }
        return null;
    }

    generateLabel(treeNode, labelEl) {
        const name = treeNode.getValue().name;
        labelEl.innerHTML = this.selectorFilter.highlightTokens(name);
        labelEl.title = this.getTitle(treeNode.getValue());
    }

    getSpecificNodeClassName() {
        return "expandCollapseNode";
    }

    getEmptyEntityTooltip() {
        //abstract
    }

    getTitle(entity) {
        return entity.name;
    }
}


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/ExpandCollapseNodeRenderer.js